import React, { Component } from 'react';
import './TabDataDistributor.scss';

import SingleDataDistributor from '../SingleDataDistributor';
import PopOverMenu from '../../Elements/Atoms/PopOverMenu';
import CreatePopMenu from '../../Elements/Molecules/CreatePopMenu';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { builBotByData, blockUiFun, highlightSearchedResult, updateBotValue } from '../../Redux/Actions/uiActions';
import { Modal } from "react-ui-lib";
import { updateSpecificValue } from '../../Utils/index';

import addOptionIcon from '../../../assets/icons/ic_add_blue.png';
import clearIcon from '../../../assets/icons/ic_close_light_grey.png';
import ImgTag from '../../Elements/Atoms/ImgTag';

class TabDataDistributor extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            buildState: 'live',
            buildMessage: ''
        }
    }

    getConfDetails = (array) => {
        let tempConfString = '';
        for (let index = 0; index < array.length; index++) {
            tempConfString += array[index];
            if (index < (array.length - 1)) {
                tempConfString += ' > ';
            }
        }
        return tempConfString;
    }

    getReadableName = (actualName) => {
        if (actualName) {
            const readableName = actualName.replace(/-|_|\//g, ' ');
            return readableName;
        }
    }

    rederSingleData = (data) => {
        const dataToBeRendered = data.data;
        if (!dataToBeRendered) {
            return;
        }
        const dataKeys = Object.keys(dataToBeRendered);
        if (!dataKeys.length) {
            return <span className='empty-object-state'> Empty Object </span>
        }

        const nonGroupContent = dataKeys.map((key, i) => {
            if (dataToBeRendered[key].ELEM_TYPE !== 'group' && dataToBeRendered[key].ELEM_TYPE !== 'object-group' && dataToBeRendered[key].ELEM_TYPE !== 'attach-file' && dataToBeRendered[key].ELEM_TYPE !== 'attachment-group') {
                if (key !== 'ELEM_TYPE' && key !== 'ELEM_DESC' && key !== 'BOTID' && key !== 'ENVIRONMENT') {
                    return (
                        <SingleDataDistributor tempdata={
                            {
                                ...data,
                                data: dataToBeRendered[key],
                                title: key,
                                parentArray: [...data.parentArray, key]
                            }
                        } key={i} />
                    );
                }
                else return null
            }
            else return null
        });

        return nonGroupContent;
    }

    addDashboardButtons = (props) => {
        return (
            <div className='config-input-area btn-wrapper build-buttons'>
                <button className='btn btn-default eb-btn-style eb-gradient-btn-linear'
                    onClick={
                        (e) => {
                            this.setState({ buildState: 'live-check', buildMessage: 'Please confirm if you want to publish the changes.' }, () => {
                                this.toggleModal(props);
                            })
                        }
                    }
                >Publish</button>
                <button className='btn btn-default eb-btn-style'
                    onClick={
                        (e) => {
                            // console.log('build local');
                            this.props.blockUiFun(true, true);
                            props.builBotByData('local', props.editableBotData.UI_OPTIONS.DASHBOARD.LOCAL_SERVER_IP_PORT.VALUE, (res) => {
                                if (res && res.error && res.error.code && res.error.message && res.error.message !== '') {
                                    this.setState({ buildState: 'local-err', buildMessage: res.error.message }, () => {
                                        this.toggleModal();
                                    })
                                } else if (res && res.error) {
                                    this.setState({ buildState: 'local-err', buildMessage: 'Something went wrong =>' + JSON.stringify(res) }, () => {
                                        this.toggleModal();
                                    })
                                } else {
                                    this.setState({ buildState: 'local' }, () => {
                                        this.toggleModal();
                                    })
                                }
                                this.props.blockUiFun(false);
                            }, (error) => {
                                this.setState({ buildState: 'local-err', buildMessage: 'Something went wrong =>' + error.msg }, () => {
                                    this.toggleModal();
                                })
                                this.props.blockUiFun(false);
                            });
                        }
                    }
                >Local Build</button>
            </div>
        );
    }

    onsubmitCallback = () => {
        // console.log('build Live');
        this.toggleModal();
        this.props.blockUiFun(true, true);
        this.props.builBotByData('live', this.props.editableBotData.SETTINGS.SERVER_IP_PORT.VALUE, (res) => {
            if (res && res.error && res.error.code && res.error.message && res.error.message !== '') {
                this.setState({ buildState: 'live-err', buildMessage: res.error.message }, () => {
                    this.toggleModal();
                })
            } else if (res && res.error) {
                this.setState({ buildState: 'live-err', buildMessage: 'Something went wrong =>' + JSON.stringify(res) }, () => {
                    this.toggleModal();
                })
            } else {
                this.setState({ buildState: 'live' }, () => {
                    this.toggleModal();
                    try {
                        if (document.getElementById('live_bot_iframe') && document.getElementById('live_bot_iframe').src)
                            document.getElementById('live_bot_iframe').src = document.getElementById('live_bot_iframe').src + '?_=' + new Date().getTime();
                    } catch (e) {
                        // console.log(e);
                    }
                })
            }
            this.props.blockUiFun(false);
        }, () => {
            this.props.blockUiFun(false);
        });
    }

    addTempDivToScroll = () => {
        return (<div ref={searchedNode => this.searchedNode = searchedNode}></div>)
    }

    scrollToRef = (ref) => {
        // if(ref.current)
        ref.scrollIntoView();
        // this.props.highlightSearchedResult({});
    }

    executeScroll = () => {
        setTimeout(() => {
            if (this.searchedNode)
                this.scrollToRef(this.searchedNode)
        }, 200)
    };

    updateDataOnLocation = ({ data, parentArray, title, isGeneric }) => {
        let tempConfigData = isGeneric ? this.props.genericBotData : this.props.editableBotData;
        if (parentArray.length === 2) {
            if (parentArray[0] === 'SETTINGS') {
                tempConfigData[parentArray[0]][parentArray[1]]['VALUE'].push({})
            } else {
                tempConfigData.UI_OPTIONS[parentArray[0]][parentArray[1]]['VALUE'].push({})
            }
        } else if (parentArray.length === 3) {
            if (parentArray[0] === 'SETTINGS') {
                tempConfigData[parentArray[0]][parentArray[1]][parentArray[2]]['VALUE'].push({})
            } else {
                tempConfigData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]]['VALUE'].push({})
            }
        } else if (parentArray.length === 4) {
            if (parentArray[0] === 'SETTINGS') {
                tempConfigData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]]['VALUE'].push({})
            } else {
                tempConfigData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]]['VALUE'].push({})
            }
        } else if (parentArray.length === 5) {
            if (parentArray[0] === 'SETTINGS') {
                tempConfigData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]]['VALUE'].push({})
            } else {
                tempConfigData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]]['VALUE'].push({})
            }
        } else if (parentArray.length === 6) {
            if (parentArray[0] === 'SETTINGS') {
                tempConfigData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]]['VALUE'].push({})
            } else {
                tempConfigData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]]['VALUE'].push({})
            }
        } else if (parentArray.length === 7) {
            if (parentArray[0] === 'SETTINGS') {
                tempConfigData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]]['VALUE'].push({})
            } else {
                tempConfigData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]]['VALUE'].push({})
            }
        } else if (parentArray.length === 8) {
            if (parentArray[0] === 'SETTINGS') {
                tempConfigData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]]['VALUE'].push({})
            } else {
                tempConfigData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]]['VALUE'].push({})
            }
        } else if (parentArray.length === 9) {
            if (parentArray[0] === 'SETTINGS') {
                tempConfigData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]]['VALUE'].push({})
            } else {
                tempConfigData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]]['VALUE'].push({})
            }
        } else if (parentArray.length === 10) {
            if (parentArray[0] === 'SETTINGS') {
                tempConfigData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]]['VALUE'].push({})
            } else {
                tempConfigData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]]['VALUE'].push({})
            }
        } else if (parentArray.length === 11) {
            if (parentArray[0] === 'SETTINGS') {
                tempConfigData[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]][parentArray[10]]['VALUE'].push({})
            } else {
                tempConfigData.UI_OPTIONS[parentArray[0]][parentArray[1]][parentArray[2]][parentArray[3]][parentArray[4]][parentArray[5]][parentArray[6]][parentArray[7]][parentArray[8]][parentArray[9]][parentArray[10]]['VALUE'].push({})
            }
        }
        this.props.updateBotValue(tempConfigData);
    }

    addGroupObjectButton = (data) => {
        let tempArr = data?.data?.VALUE
        let haveEmpty = 0;
        tempArr.length && tempArr.forEach((elm, i, arr) =>{
            if(elm && Object.keys(elm).length === 0) {
                haveEmpty++;
            }
        });
        return (
            <div className='eb-add-group-icon'>
                <span className='eb-icon-btn-image' onClick={() => {
                    if(haveEmpty < 1)
                        this.updateDataOnLocation(data);
                    else
                        alert('Empty object already exist');
                }}>
                    <ImgTag
                        className='image'
                        src={addOptionIcon}
                        alt='Add'
                    />
                    Add Object
                </span>
            </div>
        );
    }

    removeCurrentField = (parentArray, arrayData, arrType, arrayIndex) => {
        const newArr = arrayData.filter((e, i) => i !== arrayIndex);
        let editableBotData = this.props.tempdata.isGeneric ? this.props.genericBotData : this.props.editableBotData;
        if (arrType === 'arrAttachment') {
            this.props.updateBotValue(updateSpecificValue(newArr, parentArray, editableBotData, 'arrAttachment'));
        } else {
            this.props.updateBotValue(updateSpecificValue(newArr, parentArray, editableBotData, 'array'));
        }
    };

    groupDataDistributor = (tempdata, i, groupType) => {
        const parentMatch = JSON.stringify(tempdata.parentArray) === JSON.stringify(this.props.highlightSearchedData.parent);
        const labelClassName = 'config-title' + (this.props.highlightSearchedData.parent && this.props.highlightSearchedData.parent.length && parentMatch ? ' highlighted' : '');
        if(!this.props.tempdata.isGeneric) {
            if (!this.props.kbId && tempdata.title === 'DOCBRAIN') {
                return ''; // for Dockbrain / KB do not add the group if kbId is not there.
            }
        }
        // let newUi = this.props.editableBotData?.CHATBOT?.CUSTOMISE_YOUR_BOT?.USER_INTERFACE?.New && this.props.editableBotData.CHATBOT.CUSTOMISE_YOUR_BOT.USER_INTERFACE.New === true ? true : false;
        // if(!newUi && tempdata.title.indexOf("NEW_UI") === 0) {
        //     return;
        // }
        // if(newUi && tempdata.title.indexOf("OLD_UI") === 0) {
        //     return;
        // }
        return (
            <div className='config-group-block' key={i}>
                {parentMatch ? this.addTempDivToScroll() : null}
                <div className='config-label'>
                    <label className={labelClassName}>{this.getReadableName(tempdata.title)}</label>
                    { groupType ?
                        <div className='more-options-btn-wrapper popover-inactive'>
                            <PopOverMenu
                                groupDesc={tempdata && tempdata.data && tempdata.data.ELEM_DESC ? tempdata.data.ELEM_DESC : 'NA'}
                                groupType={tempdata && tempdata.data && tempdata.data.ELEM_TYPE ? tempdata.data.ELEM_TYPE : 'NA'}
                                groupConfDetails={this.getConfDetails(tempdata.parentArray)}
                                groupTitle={tempdata ? tempdata.title : ''}
                                tempdata={tempdata}
                                parent={tempdata.parentArray}
                            />
                        </div>
                        : ''
                    }
                </div>
                {tempdata.executableArray && tempdata.objectArrValue.length > 1 && (tempdata.parentArray.length >= 3 && tempdata.parentArray[2] !== 'RATING') ? 
                    <span className='array-input-clear-iocn-wrapper object-input-clear-iocn-wrapper' onClick={
                        (e) => {
                            const tempParentArr = [...tempdata.parentArray];
                            tempParentArr.splice(-1);
                            this.removeCurrentField(tempParentArr, tempdata.objectArrValue, 'array', i);
                        }
                    }>
                        <ImgTag
                            alt='clear'
                            className='array-input-clear-iocn'
                            src={clearIcon}
                        />
                    </span>
                    : null}
                <div className='config-group-area'>
                    <div className='config-inputs-wrapper'>
                        <div className='container-fluid single-inputs-wrapper no-padding'>
                            {groupType && (groupType === 'object-group' || groupType === 'optional-group') ? null : this.rederSingleData(tempdata)}
                        </div>
                        <div className='container-fluid group-inputs-wrapper no-padding'>
                            {groupType && groupType === 'optional-group' ? this.rederOptionalGroupeData(tempdata) : groupType && groupType === 'object-group' ? this.rederObjectGroupData(tempdata) : this.rederGroupeData(tempdata)}
                            {((groupType && groupType === 'object-group') && (tempdata.parentArray.length >= 3 && tempdata.parentArray[2] !== 'RATING')) ? this.addGroupObjectButton(tempdata) : null}
                        </div>
                    </div>
                    { !(groupType && groupType === 'object-group') && <div className='icon-button-wrapper go-float-right'>
                        <CreatePopMenu
                            className='eb-icon-btn-style add-new-input'
                            parentArray={tempdata.parentArray}
                        />
                    </div>}
                </div>
                {this.executeScroll()}
            </div>
        );
    }

    rederOptionalGroupeData = (data) => {
        const dataToBeRendered = data.data;
        if (!dataToBeRendered) {
            return null;
        }
        let dataKeys = Object.keys(dataToBeRendered);
        if(dataKeys.length) {
            dataKeys = dataKeys.filter((elm) => elm.indexOf('GROUP_') === 0 )
        }

        return (
            <>
                <div className='container-fluid single-inputs-wrapper no-padding'>
                    {
                        <SingleDataDistributor tempdata={
                            {
                                ...data,
                                data: dataToBeRendered.OPTIONS,
                                title: 'OPTIONS',
                                parentArray: [...data.parentArray, 'OPTIONS'],
                                optionalGroup: true
                            }
                        } key={99999} />
                    }
                </div>
                <div className='container-fluid group-inputs-wrapper no-padding'>
                    {
                        dataKeys.map((elm, i) => {
                            let selectedVal = dataToBeRendered.VALUE.toLowerCase();
                            let groupToBeShown = elm.slice(6, elm.length).toLowerCase();
                            if(selectedVal === groupToBeShown) {
                                return this.groupDataDistributor({
                                    ...data,
                                    data: dataToBeRendered[elm],
                                    title: elm,
                                    parentArray: [...data.parentArray, elm]
                                }, i);
                            } else {
                                return null;
                            }
                        })
                    }
                </div>
            </>
        );
    }

    rederObjectGroupData = (data) => {
        const dataToBeRendered = data.data;
        if (!dataToBeRendered) {
            return;
        }

        const groupContent = dataToBeRendered.VALUE.map((key, i) => {
            return this.groupDataDistributor({
                ...data,
                data: key,
                title: 'Object ' + (i + 1),
                parentArray: [...data.parentArray, 'Object ' + (i + 1)],
                executableArray: [...data.parentArray, i],
                objectArrValue: dataToBeRendered.VALUE
            }, i);
        });

        return groupContent;
    }

    rederGroupeData = (data) => {
        const dataToBeRendered = data.data;
        if (!dataToBeRendered) {
            return null;
        }
        const dataKeys = Object.keys(dataToBeRendered);
        const groupContent = dataKeys.map((key, i) => {
            if (dataToBeRendered[key].ELEM_TYPE === 'group' || dataToBeRendered[key].ELEM_TYPE === 'object-group' || dataToBeRendered[key].ELEM_TYPE === 'attach-file' || dataToBeRendered[key].ELEM_TYPE === 'attachment-group' || dataToBeRendered[key].ELEM_TYPE === 'optional-group') {
                return this.groupDataDistributor({
                    ...data,
                    data: dataToBeRendered[key],
                    title: key,
                    parentArray: [...data.parentArray, key]
                }, i, dataToBeRendered[key].ELEM_TYPE);
            }
            else return null
        });

        return groupContent;
    }

    toggleModal = (currState = true) => {
        const { isOpen } = this.state;
        if (!currState) {
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
            this.setState({ isOpen: false });
        } else {
            document.getElementsByTagName('body')[0].style.overflow = isOpen
                ? 'auto'
                : 'hidden';
            this.setState(prevState => ({
                isOpen: !prevState.isOpen
            }), () => {
                // this code is for hiding popover in sometime
                // if(this.state.isOpen && this.state.buildState !== 'live-err' && this.state.buildState !== 'local-err' && this.state.buildState !== 'live-check') {
                //     setTimeout( () => {
                //         this.setState({isOpen: false})
                //     }, 5000)
                // }
            });
        }
    };

    closeWindow = () => {
        this.toggleModal();
    }

    renderContent = () => {
        if (this.state.buildState === 'local') {
            return (
                <div className='modal-body-content'>Local bot build Completed! Changes applied to the bot</div>
            );
        } else if (this.state.buildState === 'local-err') {
            return (
                <div className='modal-body-content'>Local bot build Failed! <div className='content'>{this.state.buildMessage}</div></div>
            );
        } else if (this.state.buildState === 'live') {
            return (
                <div className='modal-body-content'>Live bot build Completed! Changes applied to the bot</div>
            );
        } else if (this.state.buildState === 'live-check') {
            return (
                <div className='modal-body-content'>{this.state.buildMessage}</div>
            );
        } else if (this.state.buildState === 'live-err') {
            return (
                <div className='modal-body-content'>Live bot build Failed! <div className='content'>{this.state.buildMessage}</div></div>
            );
        } else {
            return <div>Done</div>
        }
    };

    render() {

        const { isOpen } = this.state;
        const header = {
            title: this.state.buildState === 'live-check' ? 'Confirmation Message' : 'Flash Message',
            closeOnOutsideClick: this.state.buildState !== 'live-err' && this.state.buildState !== 'local-err' ? true : false,
            // isRemoveCloseIcon : true,  // send if needed to hide close icon on header
            style: this.state.buildState === 'live-check' ? {} : {
                // backgroundColor: 'red'
                display: 'none'
            }
        };
        const footer = {
            onSubmit: this.closeWindow,
            submitText: 'Okay',
            customStyle: {
                // backgroundColor:'blue'
                justifyContent: 'flex-end'
            },
            disableSubmit: false
        };
        const confirmationFooter = {
            onSubmit: this.onsubmitCallback,
            onCancel: this.closeWindow,
            submitText: 'Confirm',
            cancelText: 'Cancel',
            customStyle: {
                // backgroundColor:'blue'
                justifyContent: 'flex-end'
            },
            disableSubmit: false,
            disableCancel: false
        };
        const customStyle = {
            maxWidth: '550px'
        };

        const modalClassName = this.state.buildState === 'live-check' ? ' confirmation' : '';

        return (
            <div className='tab-section-wrapper' key={this.props.clearKey}>
                <div className='tab-header-wrapper'>
                    {/* <h3 className='tab-header'>{this.getReadableName(this.props.tempdata.title)}</h3> */}
                    <div className='icon-button-wrapper go-float-right'>
                        <CreatePopMenu
                            className='eb-icon-btn-style add-new-input'
                            parentArray={this.props.tempdata.parentArray}
                        />
                    </div>
                </div>

                <div className='container-fluid single-inputs-wrapper no-padding'>
                    {/* {this.props.tempdata.title === 'CUSTOMISE_YOUR_BOT' && !this.props.tempdata.isGeneric ? this.addDashboardButtons(this.props) : ''} */}
                    {this.rederSingleData(this.props.tempdata)}
                </div>

                <div className='container-fluid group-inputs-wrapper no-padding'>
                    {this.rederGroupeData(this.props.tempdata)}
                </div>

                <div className={'falsh-message-modal-container' + modalClassName}>
                    <Modal
                        isOpen={isOpen}
                        onClose={() => {this.toggleModal(false)}}
                        header={header}
                        footer={this.state.buildState === 'live-check' ? confirmationFooter : footer}
                        customStyle={customStyle}
                    >
                        {this.renderContent()}
                    </Modal>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : false,
        genericBotData: state.UiReducer && state.UiReducer.genericBotData ? state.UiReducer.genericBotData : {},
        highlightSearchedData: state.UiReducer && state.UiReducer.highlightSearchedData ? state.UiReducer.highlightSearchedData : {},
        clearKey: state.UiReducer && state.UiReducer.clearKey ? state.UiReducer.clearKey : 'clearKey',
        kbId: state.UiReducer && state.UiReducer.kbId ? state.UiReducer.kbId : undefined
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        builBotByData,
        blockUiFun,
        highlightSearchedResult,
        updateBotValue
    },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TabDataDistributor);